import React from 'react';

const BlogCategory = () => {
    return (
        <>
            {/* Blog Category */}
            <div className="blog-category">
                <h4>Categories</h4>
                <ul className="list-unstyled">
                    <li><a href="/">Business Counselling</a></li>
                    <li><a href="/">Corporate Business</a></li>
                    <li><a href="/">Audit & Assurence</a></li>
                    <li><a href="/">Web Design & Development</a></li>
                    <li><a href="/">Search Engine Optimization</a></li>
                    <li><a href="/">Graphics Design & Apply</a></li>
                </ul>
            </div>
        </>
    )
}

export default BlogCategory